export default __webpack_public_path__ + "media/images/images_v2/camembert-0b87d71a6985a8537bcc1e0fb4e5bde4.png";